import React, { useState } from "react";
import PageHeader from "./common/PageHeader";
import { FileText, Users, BarChart2, UserCheck, User, TrendingUp, CheckCircle } from "lucide-react";
import MemberExpiryReport from "./reports/MemberExpiryReport";
import NewComersCountReport from "./reports/NewComersCountReport";
import NewComersListReport from "./reports/NewComersListReport";
import TodayActiveMembersCountReport from "./reports/TodayActiveMembersCountReport";

const reportTemplates = [
  {
    key: "today-active-members-count",
    icon: <CheckCircle className="text-blue-500" size={32} />,
    title: "عدد الأعضاء النشطين اليوم",
    desc: "عدد الأعضاء النشطين اليوم (غير تجريبي)",
    color: "border-blue-200 bg-blue-50",
    button: "عرض العدد",
    component: <TodayActiveMembersCountReport />
  },
  {
    key: "member-expiry",
    icon: <Users className="text-green-600" size={32} />,
    title: "تقرير الأعضاء حسب تاريخ الانتهاء",
    desc: "عرض الأعضاء حسب تاريخ انتهاء العضوية",
    color: "border-green-200 bg-green-50",
    button: "عرض التقرير",
    component: <MemberExpiryReport />
  },
  {
    key: "newcomers-count",
    icon: <CheckCircle className="text-blue-600" size={32} />,
    title: "عدد الأعضاء الجدد",
    desc: "عدد الأعضاء الجدد خلال الفترة المحددة",
    color: "border-blue-200 bg-blue-50",
    button: "عرض العدد",
    component: <NewComersCountReport />
  },
  {
    key: "newcomers-list",
    icon: <Users className="text-purple-600" size={32} />,
    title: "قائمة الأعضاء الجدد",
    desc: "عرض قائمة الأعضاء الجدد بالتفصيل",
    color: "border-purple-200 bg-purple-50",
    button: "عرض القائمة",
    component: <NewComersListReport />
  },
  {
    key: "financial",
    icon: <BarChart2 className="text-yellow-600" size={32} />,
    title: "تقرير مالي",
    desc: "تحليل الإيرادات والمصروفات والأرباح",
    color: "border-yellow-200 bg-yellow-50",
    button: "قريباً",
    component: null
  },
  {
    key: "employee",
    icon: <UserCheck className="text-purple-600" size={32} />,
    title: "تقرير الموظفين",
    desc: "إدارة الموظفين وتقارير الأداء",
    color: "border-purple-200 bg-purple-50",
    button: "قريباً",
    component: null
  },
  {
    key: "site",
    icon: <FileText className="text-orange-600" size={32} />,
    title: "تقرير المواقع",
    desc: "تقدم وإدارة مواقع العمل",
    color: "border-orange-200 bg-orange-50",
    button: "قريباً",
    component: null
  },
  {
    key: "progress",
    icon: <TrendingUp className="text-blue-600" size={32} />,
    title: "تقرير تقدم العمل",
    desc: "تحليل تقدم المهام والزمن",
    color: "border-blue-200 bg-blue-50",
    button: "قريباً",
    component: null
  },
  {
    key: "client-status",
    icon: <User className="text-indigo-600" size={32} />,
    title: "تقرير حالة العملاء",
    desc: "تقارير حالة المشاريع للعملاء",
    color: "border-indigo-200 bg-indigo-50",
    button: "قريباً",
    component: null
  }
];

export default function ReportPage() {
  const [openReport, setOpenReport] = useState(null);
  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="قوالب التقارير السريعة" total={6} stats={[]} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {reportTemplates.map((r) => (
          <div
            key={r.key}
            className={`rounded-2xl border ${r.color} p-6 flex flex-col items-start shadow-sm`}
          >
            <div className="mb-3">{r.icon}</div>
            <div className="font-bold text-lg mb-1">{r.title}</div>
            <div className="text-gray-500 text-sm mb-4">{r.desc}</div>
            <button
              className={`w-full py-2 rounded-lg font-semibold text-white ${r.component ? "bg-green-500 hover:bg-green-600" : "bg-gray-400 cursor-not-allowed"}`}
              onClick={() => r.component && setOpenReport(r.key)}
              disabled={!r.component}
            >
              {r.button}
            </button>
          </div>
        ))}
      </div>
      {openReport && reportTemplates.find(r => r.key === openReport)?.component && (
        <div className="mt-10">
          {reportTemplates.find(r => r.key === openReport).component}
          <div className="flex justify-end mt-4">
            <button className="px-4 py-2 bg-gray-200 rounded" onClick={() => setOpenReport(null)}>إغلاق</button>
          </div>
        </div>
      )}
    </div>
  );
}
